import { contactSupportUrl } from '@/catalog/constants/support-urls';
import StatusBanner from '@/common/components/status-banner';

interface CannotOrderProps {
  hasPendingReturn: boolean;
}

export default function CannotOrder({ hasPendingReturn }: CannotOrderProps) {
  return (
    <div className="mx-[24px] md:mx-0" data-testid="cannot-order-panel">
      <StatusBanner
        variant="info"
        title={`You have a pending ${hasPendingReturn ? 'return' : 'pickup'}`}
        message={{
          text: `You cannot place a new order until you've ${
            hasPendingReturn ? 'returned' : 'picked up'
          } your car. If you have any questions, feel free to reach out.`,
        }}
        primaryLinkButton={{
          text: 'Contact Support',
          link: {
            url: contactSupportUrl,
            type: 'new-tab',
            style: 'link',
          },
        }}
      />
    </div>
  );
}
